module.exports = __webpack_public_path__ + "img/loadCom.41d8f607.png";